import { Field } from 'formik';
import type { FieldProps } from 'formik';

import type { FormData } from '../types';
import DateRelationFilter from './DateRelationFilter/DateRelationFilter';
import { HorizontalFormControl } from './HorizontalFormControl';

export type ExcludedRelations = {
  previous?: true | undefined;
  next?: true | undefined;
  current?: true | undefined;
  before?: true | undefined;
  after?: true | undefined;
  between?: true | undefined;
  in_the_last?: true | undefined;
  in_the_next?: true | undefined;
  in_this_hour?: true | undefined;
  today?: true | undefined;
  in_this_week?: true | undefined;
  in_this_month?: true | undefined;
  in_this_year?: true | undefined;
  never?: true | undefined;
};

export interface DateFilterProps {
  label: string;
  fieldName: string;
  excludedRelations: ExcludedRelations;
}

export const DateFilter = ({
  label,
  fieldName,
  excludedRelations,
}: DateFilterProps) => {
  return (
    <HorizontalFormControl label={label}>
      <Field name={fieldName}>
        {({
          field,
          form,
        }: FieldProps<FormData[typeof fieldName], FormData>) => (
          <DateRelationFilter
            excludedRelations={excludedRelations}
            error={
              form.submitCount > 0
                ? form.errors[field.name as typeof fieldName] ?? null
                : null
            }
            name={fieldName}
            value={field.value}
            onChange={(value) => {
              form.setFieldValue(field.name, value);
            }}
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
